import React, { useCallback } from 'react';
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  Flex,
  Text,
} from '@chakra-ui/react';

const ThreeDotMenuComponent = ({ icon, items }) => {
  const handleClick = useCallback((fn) => () => fn(), []);

  return (
    <Menu isLazy>
      <MenuButton
        as={IconButton}
        icon={icon}
        variant="ghost"
        color="gray"
        size="sm"
      />
      <MenuList>
        {items.map(({ icon: itemIcon, text, onClick, extraIcon }, index) => (
          <MenuItem
            key={text || index}
            fontSize="sm"
            color="gray.500"
            onClick={handleClick(onClick)}
          >
            <Flex alignItems="center">
              {itemIcon}
              <Text ml={2}>{text}</Text>
              {extraIcon && (
                <span
                  style={{
                    marginLeft: '8px',
                    display: 'inline-flex',
                    alignItems: 'center',
                  }}
                >
                  {extraIcon}
                </span>
              )}
            </Flex>
          </MenuItem>
        ))}
      </MenuList>
    </Menu>
  );
};

const ThreeDotMenu = React.memo(ThreeDotMenuComponent);

export default ThreeDotMenu;